var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"CV"}},_vm._l((3),function(i){return _c('pdf',{key:i,style:({
      'border-style': 'solid',
      'border-color': _vm.$vuetify.theme.themes.light.success,
      width: '90%',
      'margin-left': 'auto',
      'margin-right': 'auto',
      'margin-top': '4px'
    }),attrs:{"id":i,"src":(_vm.publicPath + "Schoennenbeck_CV.pdf"),"page":i}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }